import { Controller } from "@hotwired/stimulus"

// Copies the text of its source target to the clipboard, e.g. a code block.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    await navigator.clipboard.writeText(this.sourceTarget.textContent)
    this.buttonTarget.textContent = "Copied"
    clearTimeout(this.reset)
    this.reset = setTimeout(() => { this.buttonTarget.textContent = "Copy" }, 2000)
  }
}
